import { ReactNode } from 'react';

import { DASHBOARD_HEADER } from '../common/constants';
import { Main } from '../common/main';
import Header from './header';

interface IDashboardLayoutProps {
  children: ReactNode;
  noData?: boolean;
  hideNavOptions?: boolean;
}

export const DashboardLayout = ({ noData, hideNavOptions, children }: IDashboardLayoutProps) => {
  return (
    <>
      <Header navData={DASHBOARD_HEADER} noData={noData} hideNavOptions={hideNavOptions} />
      <Main>{children}</Main>
    </>
  );
};
